import http from '../shared/HttpCommon';
import { CanceledError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { CommunityManagement } from '../shared/interfaces/ICommunityManagement';

const getMonitoring = async (
  withBenchmark: boolean,
  platformWith: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get(
      `monitoring/reviews?with-benchmarks=${withBenchmark}&platform-with=${platformWith}`,
      {
        signal,
      }
    );
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const getMonitoringById = async (id: string) => {
  try {
    const { data } = await http.get(`/monitoring/reviews/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const deleteMonitoring = async (id: string) => {
  try {
    const { data } = await http.delete(`/monitoring/reviews/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const serviceBackdated = async (id: string) => {
  try {
    const { data } = await http.patch('/monitoring/admin/backdated', { monitoringId: id });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const updateMonitoringLabel = async (
  id: string,
  newLabel: string,
  newCommunitySettings: CommunityManagement
) => {
  try {
    const { data } = await http.patch('/monitoring/reviews', {
      communityManagement: newCommunitySettings,
      id: id,
      label: newLabel,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const updateMonitoringScheduler = async (id: string) => {
  try {
    const { data } = await http.get(`/monitoring/scrape/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const ReviewMonitoringService = {
  getMonitoring,
  deleteMonitoring,
  updateMonitoringLabel,
  updateMonitoringScheduler,
  getMonitoringById,
  serviceBackdated,
};

export default ReviewMonitoringService;
